import React, { useRef, useState } from 'react';
import ToastManager from './ToastManager';

const FileUpload = ({acceptedFileTypes = [], onFileUpload, isDisabled, imageUpload }:any) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [dragOver, setDragOver] = useState(false);
  const [fileName, setFileName] = useState('');
  
  const getFileExtensionFromType = (type: string): string => {
    const parts = type.split('/');
    return parts[parts.length - 1];
  };
  
  const normalizeType = (type: string) => type.replace(/^\./, '').toLowerCase();

  const isAcceptedFileType = (ext: string) =>
    acceptedFileTypes
      .map((ft:any) => normalizeType(ft))
      .includes(ext.toLowerCase());
  
  const handleFileSelect = (event:any) => {
    if (isDisabled) return;
    const file = event.target.files[0];
    if (file) {
      const ext = getFileExtensionFromType(file.type).toLowerCase();
      if (acceptedFileTypes.length && !isAcceptedFileType(ext)) {
        const allowedTypes = acceptedFileTypes.join(', ');
        ToastManager.showToast(`File type ".${ext}" is not allowed.\nAllowed types are: ${allowedTypes}.`, "Error");
        return;
      }
      setFileName(file.name);
      onFileUpload(file);
    }
    event.target.value = '';
  };

  const handleDrop = (event:any) => {
    if (isDisabled) return;
    event.preventDefault();
    setDragOver(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      const ext = getFileExtensionFromType(file.type).toLowerCase();
      if (acceptedFileTypes.length && !isAcceptedFileType(ext)) {
        const allowedTypes = acceptedFileTypes.join(', ');
        ToastManager.showToast(`File type ".${ext}" is not allowed.\nAllowed types are: ${allowedTypes}.`, "Error");
        return;
      }
      setFileName(file.name);
      onFileUpload(file);
    }
  };

  const handleDragOver = (event:any) => {
    if (isDisabled) return;
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    if (isDisabled) return;
    setDragOver(false);
  };

  const handleClick = () => {
    if (isDisabled) return;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const dropzoneStyle = {
    border: '1px dashed #D0D5DD',
    backgroundColor: isDisabled
      ? '#fbfbfb'
      : dragOver
      ? '#e0f7fa'
      : '#F9FAFB',
    transition: 'background-color 0.3s ease',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.5 : 1,
  };

  return (
    <>
    {imageUpload ? 
    <div  onClick={handleClick}>
      <input type="file" ref={fileInputRef} onChange={handleFileSelect} style={{ display: 'none' }} />
      <button type='button' disabled={isDisabled} style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}>Upload Image</button>
    </div> : 
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onClick={handleClick}
      style={dropzoneStyle} 
    >
      <input type="file" ref={fileInputRef} onChange={handleFileSelect} style={{ display: 'none' }} />
      <div className="text-center p-1">
        <img src={'./../images/upload.svg'} alt="upload" />
      </div>
      <div className="text-center pt-1">
        <span className="fw-500">
          {isDisabled ? 'Upload Disabled' : 'Click to upload'}
        </span>
        {!isDisabled && <>&nbsp;Or&nbsp;Drag and Drop</>}
      </div>
      <div
        className="text-center fw-200 pb-2"
        style={{ fontSize: '11px', color: isDisabled ? '#A0A0A0' : 'inherit' }}
      >
        {acceptedFileTypes.length
          ? acceptedFileTypes.join(', ')
          : 'Any file type'}
      </div>
    </div>}
    </>
  );
};

export default FileUpload;
